import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../../lib/result-codes";
import {
  createMerchantCoupon as createMerchantCouponApi,
  uploadCouponImage,
} from "../api/merchantCouponEditor.api";
import { MERCHANT_COUPON_NOTIFICATION_MESSAGES } from "../data/merchantCouponEditor.constants";
import type { MerchantCouponUIState } from "../data/merchantCouponEditor.data";

interface UseCreateMerchantCouponReturn {
  createMerchantCoupon: (coupon: MerchantCouponUIState) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const useCreateMerchantCoupon = (): UseCreateMerchantCouponReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createMerchantCoupon = useCallback(async (coupon: MerchantCouponUIState): Promise<void> => {
    try {
      setLoading(true);
      setError(null);

      let imageUrl = coupon.image_url;
      if (coupon.image_file && coupon.image_file instanceof File) {
        imageUrl = await uploadCouponImage(coupon.image_file);
      }

      await createMerchantCouponApi({
        ...coupon,
        image_url: imageUrl,
        image_file: undefined,
      });
    } catch (createError: unknown) {
      setError(getApiErrorMessage(createError, MERCHANT_COUPON_NOTIFICATION_MESSAGES.CREATE_ERROR));
      throw createError;
    } finally {
      setLoading(false);
    }
  }, []);

  return { createMerchantCoupon, loading, error };
};
